import React, { useState } from "react";
import "../../assets/css/responsive.css";
import "../../assets/css/style.css";
import "../../assets/css/general.css";
import "../../assets/css/hamburger.css";
import "../../assets/css/dashboard-assets.css";
import "../../assets/css/dashboard.css";

import NavBar from "../../components/general/NavBarApp.jsx";
import Footer from "../../components/general/footer.jsx";
import SalaryWidget from "../../components/dashboard/interim/salary";
import NewMission from "../../components/dashboard/interim/newMission";
import DailyTimeline from "../../components/calendar/daily-timeline";
import NextMissions from "../../components/dashboard/interim/nextMissions";
import MissionSuggestions from "../../components/dashboard/interim/missionSuggestions";
import NotificationsCenter from "../../components/notificationsCenter";
import CountWidget from "../../components/dashboard/company/countWidget";

import logo from "../../assets/img/logo.svg";
import CreateNewMission from "../../components/dashboard/company/newMission";
import TimesheetWidget from "../../components/dashboard/company/timesheetWidget";
import MissionsToComeWidget from "../../components/dashboard/company/missionsToComeWidget";

const Main = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleNotification = () => {
    setOpenNotification(!openNotification);
  };

  // Données des missions
  const missions = [
    {
      role: "Cuisinier",
      start: "08:00",
      end: "12:00",
      place: "Hotel Fontaine",
      groupId: "A",
    },
    {
      role: "Cuisinier",
      start: "15:00",
      end: "18:00",
      place: "Hotel Fontaine",
      groupId: "A",
    },
    {
      role: "Serveur",
      start: "09:00",
      end: "14:00",
      place: "Hotel Fontaine",
      groupId: "B",
    },
    {
      role: "Serveur",
      start: "16:00",
      end: "20:00",
      place: "Hotel Fontaine",
      groupId: "B",
    },
    {
      role: "Barman",
      start: "06:00",
      end: "08:30",
      place: "Bar Parisien",
      groupId: "C",
    },
  ];

  return (
    <div className="main">
      <NotificationsCenter
        isOpen={openNotification}
        setOpenNotification={setOpenNotification}
      />
      <NavBar userType="interim" />
      <div className="dashboard interim">
        <SalaryWidget />
        <NewMission />
        <NextMissions />
        <MissionSuggestions />
        <DailyTimeline missions={missions} />
      </div>
      <Footer />
    </div>
  );
};

export default Main;
